import { Button, Error, Form, Input, TextArea } from '@opengov/component-library/dist';
import React from 'react';
import { SAVED_VIEW_DESCRIPTION_MAX_LENGTH, SAVED_VIEW_TITLE_MAX_LENGTH } from './types';
import { useSavedViewForm } from './useSavedViewForm';
import styles from './SavedViewFormFields.scss';

export interface SavedViewFormLocaleText {
  cancel: string;
  createView: string;
  description: string;
  enterViewName: string;
  titleDuplicate: string;
  titlePlaceHolder: string;
}

export interface SavedViewFormFieldsProps {
  form: ReturnType<typeof useSavedViewForm>;
  localeText: SavedViewFormLocaleText;
  onClose: () => void;
  onSubmit: () => void;
}

export const SavedViewFormFields = ({ form, localeText, onClose, onSubmit }: SavedViewFormFieldsProps) => {
  const {
    cancel,
    createView,
    description: descriptionLabel,
    enterViewName,
    titleDuplicate,
    titlePlaceHolder
  } = localeText;
  const {
    title,
    description,
    titleValidationState,
    formValid,
    showTitleEmptyMessage,
    showTitleDuplicateMessage,
    handleTitleChange,
    handleDescriptionChange,
    handleTitleBlur
  } = form;

  return (
    <>
      <Form.Item required={true} label={titlePlaceHolder}>
        <Form.CharacterCounter currentCount={title.length} maxCount={SAVED_VIEW_TITLE_MAX_LENGTH} />
        <Input.Text.Large
          dataTest="savedViewModalTitle"
          onBlur={handleTitleBlur}
          onChange={handleTitleChange}
          placeholder={titlePlaceHolder}
          validationState={titleValidationState}
          value={title}
        />
      </Form.Item>
      {showTitleEmptyMessage && <Error dataTest="errorStateMessage">{enterViewName}</Error>}
      {showTitleDuplicateMessage && <Error dataTest="duplicateViewNameMessage">{titleDuplicate}</Error>}
      <br />
      <Form.Item label={descriptionLabel}>
        <Form.CharacterCounter currentCount={description.length} maxCount={SAVED_VIEW_DESCRIPTION_MAX_LENGTH} />
        <TextArea
          dataTest="savedViewModalDescription"
          onChange={handleDescriptionChange}
          placeholder={descriptionLabel}
        />
      </Form.Item>
      <br />
      <div className={styles.buttons}>
        <div className={styles.left}>
          <Button title={cancel} onClick={onClose} dataTest="cancelSavedView">
            {cancel}
          </Button>
        </div>
        <div className={styles.right}>
          <Button
            variant="primary"
            dataTest="create-and-return"
            disabled={!formValid}
            onClick={onSubmit}
            title={createView}
          >
            {createView}
          </Button>
        </div>
      </div>
    </>
  );
};
